import Modal from './modal';

const modalConfig = {
  name: 'modal',
  class: Modal,
  querySelector: {
    modalElement: '.modal__dialog',
    closeElement: '.modal__close-button',
    triggerElement: '[data-modal-trigger]',
  },
  options: {
    activeClass: 'modal-active',
  },
};

export default modalConfig;

